import Axios from 'axios'

const instance = Axios.create({
  baseURL: process.env.API_ROOT || '/wp-json/lst/v1',
  responseType: 'json'
})

const commentInstance = Axios.create({
  baseURL: process.env.API_COMMENT_ROOT || '/wp-json/wp/v2',
  responseType: 'json'
})

export default {
  install (Vue) {
    Object.defineProperty(Vue.prototype, '$axios', { value: instance })
    Object.defineProperty(Vue.prototype, '$comments', { value: commentInstance })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/axios.js